const es = {
    translation: {
        accountEnding: 'Cuenta que termina en {{accountLast4}}',
        addAuthUserScreen: {
            addAsAnAuthorizedUser: 'Agregar como un usuario autorizado',
            addAuthorizedUser: 'Agregar Usuario Autorizado a continuación',
            birthDateInputFutureError: 'La fecha está en el futuro',
            birthDateInputHelpText: 'MM/DD/AAAA',
            birthDateInputInvalidDateError: 'La fecha debe ser una fecha valida del calendario MM/DD/AAAA',
            birthDateInputPastYearError: 'El año de nacimiento está muy atrás en el pasado',
            birthDateInputPlaceholder: 'Fecha de Nacimiento del Usuario Autorizado',
            birthDateInputTodayError: 'No se puede usar la fecha de hoy',
            eachAuthorizedUser: 'Cada Usuario Autorizado podrá:',
            firstNameInputError: 'Por favor, solo escriba letras',
            firstNameInputHelpText: 'Nombre del Usuario Autorizado',
            firstNameInputPlaceholder: 'Nombre',
            lastNameInputError: 'Por favor, solo escriba letras',
            lastNameInputHelpText: 'Apellido del Usuario Autorizado',
            lastNameInputPlaceholder: 'Apellido',
            legalContent: "Una vez añadido/a, esta persona podrá hacer compras para cargar a esta cuenta y será reportada a las agencias de informes crediticios como usuario autorizado. Al hacer clic a continuación en 'Añadir usuario autorizado', usted también comprende que los usuarios autorizados no serán responsables contractualmente de pagar la cuenta. Solo el titular principal de la cuenta continuará siendo responsable de pagar todos los cargos en la cuenta. Al continuar se confirma que usted acepta estos términos.",
            membershipNumber: 'Número de Membresía',
            nameLabel: 'Nombre',
            physicalCardReceived: 'Recibir una tarjeta física con su nombre por correo postal, dirigida al titular principal de la cuenta. El usuario autorizado debería usar la tarjeta para añadirla a su billetera digital.',
            reportAccountHistory: 'Tener el historial de esta cuenta reportada en su agencia de informes crediticios.',
            spendAndUtilizeBenefits: 'Gastar en la cuenta y utilizar los beneficios al mismo tiempo que el titular principal de la cuenta.'
        },
        authorizedUser: 'Usuario Autorizado',
        button: {
            addAuthorizedUser: 'AGREGAR USUARIO AUTORIZADO',
            backToAccountServices: 'REGRESAR A SERVICIOS DE CUENTA',
            backToManageCardholders: 'REGRESAR A ADMINISTRAR TITULARES DE TARJETAS',
            cancel: 'CANCELAR'
        },
        errorMessages: {
            accessDeniedMessageBox: {
                body: 'Por favor, llame al número de servicio al cliente que figura en el reverso de su tarjeta para obtener más información.',
                title: 'Estamos teniendo problemas para verificar su identidad'
            },
            addPrimaryHolder: {
                extraInfo: 'Intente nuevamente con otro nombre.',
                subTitle: 'Usted ingresó un nombre de Titular de Tarjeta que ya tiene una tarjeta.',
                title: 'Por favor, vuelva a intentarlo'
            },
            addressChanged: 'No podemos tramitar su solicitud porque su dirección ha cambiado en los últimos 30 días.',
            addressChangedSams: 'Por favor, llame al número de servicio al cliente que figura en el reverso de su tarjeta para obtener más información.',
            nameChanged: 'No podemos tramitar su solicitud porque ha cambiado su nombre en los últimos 30 días.',
            notEligibleAccount: 'Su cuenta no es elegible',
            pleaseContactUs: 'Por favor, comuníquese con nosotros llamando al 888-746-7726 para agregar un titular de tarjeta adicional a su cuenta. ',
            profanity: {
                title: 'Por favor, vuelva a intentarlo',
                unapprovedName: 'El nombre o nombres que nos ha proporcionado no pudieron ser aceptados tal como fueron ingresados. Por favor, realice las correcciones necesarias y vuelva a intentarlo.'
            },
            troubleRetrievingInformation: 'Tenemos problemas para recuperar su información',
            tryAgainLater: 'Por favor, vuelva a intentarlo más tarde.'
        },
        existingUserMessageBox: {
            existingUser: 'El usuario que ha añadido ya es un Usuario Autorizado',
            usersList: 'Por favor, consulte la lista de usuarios que figura a continuación.'
        },
        expiredMembership: {
            subtitle: 'Por favor, comuníquese con Sam’s Club llamando al 888-746-7726 para renovar su membresía antes de poder agregar un titular de tarjeta adicional a su cuenta.',
            title: 'Su membresía de Sam’s Club ha vencido'
        },
        headerSubTitle: 'Puede agregar {{usersLimit}} Usuario(s) Autorizados más a esta cuenta.',
        headerTitle: 'Agregar Usuario Autorizado a continuación',
        historyCreditBureau: 'Tener el historial de esta cuenta reportada en su agencia de informes crediticios.',
        maximumMessageBox: {
            addAnotherAuthorizedUser: 'Para agregar a otro Usuario Autorizado, primero elimine uno de los Usuarios Autorizados actuales llamando al número que está en el dorso de su tarjeta o use nuestro <onlineChatLink>{{onlineChatText}}</onlineChatLink>',
            onlineChat: 'Chat en Línea',
            title: 'Usted ha alcanzado el número máximo de Usuarios Autorizados'
        },
        missingSomeone: '¿Se Le Olvida Alguien?',
        newAuthorizedUser: {
            title: 'Nuevo Usuario Autorizado'
        },
        noAccountAddedMessage: 'Actualmente, usted es el único titular de tarjeta para esta cuenta.',
        noEligibleMembersFound: 'No se hallaron miembros elegibles.',
        note: '<strong>Nota:</strong> Para agregar a un Usuario Autorizado, primero debe agregarlo a su membresía de Sam’s Club.',
        notEligibleMessageBox: {
            subtitle: 'Su Membresía de Sam’s Club no es elegible para titulares de tarjeta autorizados. Por favor, comuníquese con Sam’s Club llamando al 888-746-7726 o visite <samsLink>SamsClub.com</samsLink> para administrar su membresía.',
            title: 'Su Membresía de Sam’s Club no es elegible para titulares de tarjeta autorizados'
        },
        steps: {
            title: 'Para añadir un Usuario Autorizado, añádalos a su Membresía Sam’s Club.',
            one: 'Visite <samsLink>SamsClub.com</samsLink> para añadirlos a su membresía',
            two: 'Vuelva a cargar la página Administrar Titulares De Tarjetas en SamsClub.com después de añadir nuevos miembros'
        },
        successfulMessageBox: {
            bold: ' 7 a 10 días hábiles.',
            subtitle: 'La nueva tarjeta llegará a la dirección postal registrada en su cuenta en los próximos',
            title: 'Usted ha agregado exitosamente a un nuevo Usuario Autorizado.',
            waitTimeToBeReflected: '<strong>Nota:</strong> Puede demorar hasta 30 minutos en agregarse este nuevo usuario a su cuenta.'
        },
        unableToProcessReq: 'Lamentablemente no podemos procesar su solicitud en este momento.',
        verifyMessageBox: {
            body: 'Tenemos que asegurarnos de que realmente sea usted. <verifyUserLink>Por favor, verifique su cuenta.</verifyUserLink>',
            title: 'Agregar un Usuario Autorizado'
        }
    }
};
export default es;
